import axios from '../../../axios';
import IBulkFileUploadDTo from '../types/IBulkFileUploadDTO';
import IFileInfoDTO from '../types/IFileInfoDTO';

const url = '/api/s3/';

const jobCandidateInteractionUrl = '/api/job-candidate-interactions/';

export const getPresignedURLForPut = (fileInfo: IFileInfoDTO) =>
  axios.post(url + 'presigned-url-for-put', fileInfo);
export const fileUploadToS3 = (file: File, preSignedUrl: string, onUploadProgress?: any) => {
  axios.defaults.withCredentials = false;
  return axios.put(preSignedUrl, file, {
    headers: {
      'Content-Type': file.type,
      Authorization: '',
    },
    onUploadProgress,
  });
};
export const getPresignedURLForGet = (fileInfo: IFileInfoDTO) =>
  axios.post(url + 'presigned-url-for-get', fileInfo);

export const downloadCvAsPDF = (fileInfo: IFileInfoDTO) =>
  axios.post(url + 'download-html-as-pdf', fileInfo, { responseType: 'arraybuffer' });

export const getResumePreview = (s3url: string, source: string) =>
  axios.get('/api/s3/get-resume-preview', { params: { s3Url: s3url, source: source } });

export const uploadAttachment = (fileInfo: IFileInfoDTO) =>
  axios.post(jobCandidateInteractionUrl + 'presigned-url-for-put', fileInfo);

export const uploadFileToS3 = async (file: File, onUploadProgress?: any) => {
  const request: IFileInfoDTO = {
    fileName: file.name,
    fileType: file.type,
  };
  const response = await getPresignedURLForPut(request);
  if (response?.data) {
    const resp = response.data;
    await fileUploadToS3(file, resp.preSignedUrl, onUploadProgress);
    return resp.preSignedUrl;
  }
  return '';
};

export const getBulkPresignedURLForPut = (bulkFile: IBulkFileUploadDTo) =>
  axios.post(url + 'bulk-presigned-url-for-put', bulkFile);
